import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';
import { PortalContentKv, PortalItemDto, PortalSlideDto, PublicPortalContent } from '../models/portal';

@Injectable({ providedIn: 'root' })
export class PortalContentService {
  private baseUrl = `${environment.apiUrl}/PortalContent`;

  constructor(private http: HttpClient) {}

  mediaUrl(id?: string | null): string | null {
    return id ? `${environment.apiUrl}/Media/${id}` : null;
  }

  /** Uploads an image and returns its media id (Guid). */
  uploadImage(file: File): Observable<ApiResponse<string>> {
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ApiResponse<string>>(`${environment.apiUrl}/Media/upload`, fd);
  }

  getPublic(): Observable<ApiResponse<PublicPortalContent>> {
    return this.http.get<ApiResponse<PublicPortalContent>>(`${this.baseUrl}/Public`);
  }

  // ── admin ────────────────────────────────────────────────────────────────
  getAll(): Observable<ApiResponse<PublicPortalContent>> {
    return this.http.get<ApiResponse<PublicPortalContent>>(`${this.baseUrl}/All`);
  }
  upsertContent(items: PortalContentKv[]): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.baseUrl}/UpsertContent`, items);
  }
  saveSlide(dto: PortalSlideDto): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(`${this.baseUrl}/SaveSlide`, dto);
  }
  deleteSlide(id: string): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.baseUrl}/DeleteSlide/${id}`);
  }
  saveItem(dto: PortalItemDto): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(`${this.baseUrl}/SaveItem`, dto);
  }
  deleteItem(id: string): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.baseUrl}/DeleteItem/${id}`);
  }
}
